<template>
  <div class="file-uploader">
    <button class="buttons button-one mb-2" @click="close()">Close</button>
      <DropZone :maxFiles="maxFiles()"
              :maxFileSize="100000000"
              :uploadOnDrop="true"
              :multipleUpload="multipleUpload"
              :parallelUpload="1"
              :xhrTimeout="Number(900000)"
              method="POST"
              paramName="userFile"
              @sending="sending"
              @added-file="addedFile"             
              @uploaded="uploaded"
              @errorUpload="onErrorUpload"
              :url="url">
              <template v-slot:message>
                <div v-if="subscription.data.subscription_type!==0" v-html="message_premium"></div>
                <div v-else v-html="message_default"></div>
              </template>
      </DropZone>
    <p></p>
    <div class="processing-message">{{ processing_message }}</div>
    <div class="form-check form-switch">
      <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" :disabled="subscription.data.subscription_type!==0 ? false : true" v-model="checked">
      <label class="form-check-label" for="flexSwitchCheckDefault">Enable model update <i class="fa-solid fa-question" data-bs-toggle="tooltip" title="Available for Premium or Business Plans"></i></label>
    </div>
    
    <div class="response-message" >
      <div v-if="error_array.length>0">
        <div style="margin-bottom:1rem;">There was an error processing the following files:</div>
        <p style="margin-bottom: 0rem;" v-for="error_data,index in error_array" :key="index"><b>{{error_data.filename}}</b> : {{error_data.response.error}}</p>      
        <div style="margin-top:1rem;">Please try again or contact the support.</div>
      </div>
    </div>
  </div>
</template>

<script>
import DropZone from 'dropzone-vue';
//import axios from 'axios'
//import commonProp from '../common/common.js'
//const common = new commonProp();
// optionally import default styles
import 'dropzone-vue/dist/dropzone-vue.common.css';
import { Tooltip } from 'bootstrap/dist/js/bootstrap.esm.min.js'
export default  {
  name:'file-uploader',
  components: {
    DropZone
  },
  props: [
    'uploadUrl',
    'subscription'
  ],
  created() {
    this.url = this.uploadUrl;
  },
  data() {
    return {
      url:'',
      multipleUpload:false,
      checked:false,
      error_array:[],
      file_added_counter:0,
      file_processed_counter:0,
      response_message:'',
      processing_message: '',   
      message_default: "<br>DRAG YOUR FILE OR CLICK IN THE BOX ...<br><br><i class='fa-regular fa-file' style='font-size:60px;'></i><br><br>Files Supported: STEP,IGES,GLTF (as zip file),3MF,STL,PLY,OBJ (with MTL and TEXTURE as ZIP file), 2D-DXF and 2D-DWG<br><br>Max size: 50MB<br>",
      message_premium: "<br>DRAG YOUR FILE OR CLICK IN THE BOX ...<br><br><i class='fa-regular fa-file' style='font-size:60px;'></i><br><br>Files Supported: STEP,IGES,GLTF (as zip file),3MF,STL,PLY,OBJ (with MTL and TEXTURE as ZIP file), 2D-DXF and 2D-DWG<br><br>Max size: 100MB<br>"
    }
  },
  watch: {
    file_processed_counter: function() {
      this.checkIfAllFilesAreProcessed()
    }
  },
  mounted() {    
    //inti tooltip
    Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
      .forEach(tooltipNode => new Tooltip(tooltipNode))
  },
  methods: {
    close() {
      this.$emit('closeUpload')
    },
    sending(file, xhr, formData) {
      //add updatedmodel only if selected
      if (this.checked===true){
        formData.append("updatemodel",true);
      }

      this.processing_message='Uploading...'

      if (this.$gtm.enabled()) {                            
         window.dataLayer?.push({
         'event' : 'upload'
      })}
      
      //we need to retrieve the xhr response as we need to get the message from
      //the server  
      var _this = this

      xhr.upload.onloadend = function() {
          _this.processing_message='Processing...this could take a few minutes'
          //console.log('upload complete')
      };

      xhr.onreadystatechange = function() {
        var status
        if (xhr.readyState == 4) { // `DONE`
            status = xhr.status
            if (status == 200) {
              _this.update_error_array(file,xhr.response)
              _this.processing_message=''
              _this.file_processed_counter++        
            } 
        }
      }
      
    },
    /*uploaded(items) {
      // the file has been uploaded
      console.log(items)
    },*/
    onErrorUpload() {
      this.processing_message='Timeout'
      //console.log(error)
    },
    update_error_array(file,response) {    
      var JSONresponse=JSON.parse(response)
      if (JSONresponse.success===false){
        //update error array
        this.error_array.push({"filename":file[0].name,"response":JSONresponse})
        //console.log(this.error_array)
        if (this.$gtm.enabled()) {                            
          window.dataLayer?.push({
          'event' : 'uploadError'
        })}
      }
    },
    addedFile() {
      // the file has been added
      this.file_added_counter++
      //console.log(this.upload_counter)
    },
    checkIfAllFilesAreProcessed(){
      //console.log(this.file_added_counter,this.file_processed_counter)
      if (this.file_processed_counter==this.file_added_counter){
        this.processing_message='All files processed, you can close the window'
      }
    },
    maxFiles(){
      //this needs to be executed when Dropzone is initialized
      if (this.subscription && !this.subscription.error) {
        if (this.subscription.data){                              
          if (this.subscription.data.subscription_type == 0){
             return 1
          } else {
            return 100          
          }
        }
      }
    }
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/fileUploader.scss";

.dropzone__item-thumbnail{
    background-image: url("@/assets/3d-file-icon.png"); 
    background-size: contain;
    background-repeat: no-repeat;
    opacity: 0.4;
}
</style>